// extracted by mini-css-extract-plugin
export default {"pinkButton":"Button_pinkButton__ilgni"};